var map = {
	"./amazon.png": "ca55",
	"./amazon_integ_dark.png": "b4e0",
	"./amazon_integ_light.png": "8c78",
	"./cdiscount.png": "d58ff",
	"./cdiscount_integ_dark.png": "9851",
	"./cdiscount_integ_light.png": "c630",
	"./etsy.png": "b027",
	"./etsy_integ_dark.png": "ccba",
	"./etsy_integ_light.png": "459e",
	"./fnac.png": "c2bc",
	"./fnac_integ_dark.png": "1f4f",
	"./fnac_integ_light.png": "976b",
	"./linn_integ_dark.png": "94ec",
	"./linn_integ_light.png": "294f",
	"./linnworks.png": "322b",
	"./mirakl.png": "3bf3",
	"./mirakl_integ_dark.png": "c344",
	"./mirakl_integ_light.png": "fca3",
	"./realde.png": "cc43",
	"./realde_integ_dark.png": "4c5d",
	"./realde_integ_light.png": "84dc",
	"./schenker.png": "8c19",
	"./schenker_integ_dark.png": "e76c",
	"./schenker_integ_light.png": "fde7",
	"./shopify.png": "0bfa",
	"./shopify_integ_dark.png": "be5d",
	"./shopify_integ_light.png": "6985"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1363";